package kz.dentalcrm.app.screens.quick_replies.list.mvi

import kz.dentalcrm.app.core.base.ViewEvent
import kz.dentalcrm.app.data.network.response_model.quick_replies.QuickReply

sealed interface QuickRepliesViewEvent : ViewEvent {
    data class SearchQuickReply(val search: String) : QuickRepliesViewEvent
    data object LoadMore : QuickRepliesViewEvent
    data object Reload : QuickRepliesViewEvent
    data class EditQuickReply(val quickReply: QuickReply) : QuickRepliesViewEvent
    data class DeleteQuickReply(val id: Int) : QuickRepliesViewEvent
}
